<template>
  <div class="store__product-detail">
    <h1 class="store-headline">Product Detail</h1>

    <div v-if="storeProductsAreLoaded && ! product">
      <p>The product you searched for could not be found.</p>
      <router-link :to="{ name: 'products' }" class="btn btn--main btn-shadow"><i class="fal fa-angle-left" aria-hidden="true"></i> Continue Shopping</router-link>
    </div>

    <div v-else-if="!storeProductsAreLoaded" class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>

    <div v-if="product">
      <component 
        :is="{...productComponent}" 
        :product="product"
      ></component>

      <related-products 
        :product="product"
      ></related-products>
    </div>

  </div> <!-- .store__product-detail -->
</template>

<script>
import store  from '../store.js'
import RelatedProducts from './RelatedProducts.vue'
import ProductDefault from './products/Default.vue'

export default {
  data() {
    return {
      product: null,
      productId: null,
      productComponent: null,
    }
  },
  components: {
    RelatedProducts,
  },
  computed: {
    storeProductsAreLoaded() {
      return store.state.products.length > 0
    }
  },
  watch: {
    // Once all the products have loaded, load the requested product.
    storeProductsAreLoaded() {
      if (this.storeProductsAreLoaded) {
        this.productId = this.$route.params.productId
        this.loadProduct()
        store.dispatch('setCurrentStep', 'products')
        store.dispatch('setPageMetaInfo')
      }
    }
  },
  mounted() {
    if (this.storeProductsAreLoaded) {
      this.productId = this.$route.params.productId
      this.loadProduct()
      store.dispatch('setCurrentStep', 'products')
      store.dispatch('setPageMetaInfo')
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.productId = to.params.productId
    this.loadProduct()
    next()
  },
  methods: {
    loadProduct() {
      switch (this.productId) {
        default:
          this.product = store.getters.getProductById(this.productId)
          this.productComponent = ProductDefault
          break
      }
    }
  }
}
</script>
